export var DNCDataMapper = function (resp) {
    if (resp) {
        return {
            strMsg: resp.strMsg,
            strContactLnk: resp.strContactLnk,
        };
    }
    return {};
};
